__turbopack_context__.v({
  "className": "satoshi_c7b437ec-module__uGQpLG__className",
  "variable": "satoshi_c7b437ec-module__uGQpLG__variable",
});
